import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["src", "title"]
const _hoisted_2 = { class: "header-buttons" }
const _hoisted_3 = ["onClick", "title"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "error"
}
const _hoisted_7 = { class: "error-buttons" }
const _hoisted_8 = { class: "toast-list" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "alert alert-info",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("img", {
        src: require('@/assets/logo.png'),
        alt: "Logo Berner Fachhochschule",
        class: "logo",
        title: 
        'enerKI Version: ' +
        $setup.version +
        '\nModel: ' +
        $setup.store.connection.BASE_URL +
        ' > ' +
        $setup.store.connection.MODEL
      
      }, null, 8 /* PROPS */, _hoisted_1),
      _cache[2] || (_cache[2] = _createElementVNode("h1", null, "enerKI", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getHeaderButtons(), (b) => {
          return (_openBlock(), _createElementBlock("a", {
            onClick: b.action,
            title: b.title,
            class: "header-button",
            style: _normalizeStyle(b.style)
          }, _toDisplayString(b.icon), 13 /* TEXT, STYLE, PROPS */, _hoisted_3))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ]),
    ($setup.showSettings)
      ? (_openBlock(), _createBlock($setup["Settings"], {
          key: 0,
          onOnClose: $setup.closeSettings
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createCommentVNode(" if no token is set, we show the auth form "),
          ($setup.token?.length == 0)
            ? (_openBlock(), _createBlock($setup["AuthForm"], {
                key: 0,
                onOnToken: $setup.setToken,
                onOnError: $setup.handleError
              }))
            : (_openBlock(), _createElementBlock("main", _hoisted_5, [
                _createCommentVNode(" display error message "),
                ($setup.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("h2", null, _toDisplayString($setup.i18n('ERROR')), 1 /* TEXT */),
                      _createTextVNode(" " + _toDisplayString($setup.error) + " ", 1 /* TEXT */),
                      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", { onClick: $setup.reset }, _toDisplayString($setup.i18n('RESET')), 1 /* TEXT */),
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.error = ''))
                        }, _toDisplayString($setup.i18n('OK')), 1 /* TEXT */)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createCommentVNode(" chat window "),
                      _createVNode($setup["Chat"], {
                        token: $setup.token,
                        percent: $setup.percent,
                        onOnError: $setup.handleError
                      }, null, 8 /* PROPS */, ["token", "percent"])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                _createCommentVNode(" window for power simulation / debug "),
                ($setup.store.connected && $setup.store.isPedalling() && !$setup.error)
                  ? (_openBlock(), _createBlock($setup["PowerSimulator"], {
                      key: 2,
                      debug: $setup.store.isDebug,
                      watt: Math.round($setup.store.power.getValues().value)
                    }, null, 8 /* PROPS */, ["debug", "watt"]))
                  : _createCommentVNode("v-if", true)
              ])),
          (!$setup.store.connected)
            ? (_openBlock(), _createBlock($setup["ConnectModal"], {
                key: 2,
                onOnError: $setup.handleError
              }))
            : _createCommentVNode("v-if", true),
          ($setup.store.activeCard && $setup.showCardModal)
            ? (_openBlock(), _createBlock($setup["QuizCardModal"], {
                key: 3,
                card: $setup.store.activeCard,
                onOnClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showCardModal = false))
              }, null, 8 /* PROPS */, ["card"]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("ul", _hoisted_8, [
            _createCommentVNode("li v-for=\"(toast, i) of store.toasts\" :style=\"getToastOpacity(i)\">\n        <div class=\"alert alert-info\" role=\"alert\">\n          {{ toast }}\n        </div>\n      </li"),
            ($setup.store.toasts.length > 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString($setup.store.toasts.at(-1)), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
  ], 64 /* STABLE_FRAGMENT */))
}